/**
 * Entity Feature Routes
 */

import type { RouteRecordRaw } from 'vue-router';
import { useSessionStore } from '@/shared/stores/sessionStore';

// jurisdiction이 MY가 아닌지 확인하는 가드 (MY이면 entity_my로 리다이렉트)
const checkJurisdictionNotMY = (to: any, from: any, next: any) => {
    const sessionStore = useSessionStore();
    const customerInfo = sessionStore.getCustomerInfo();
    
    if (customerInfo?.jurisdiction === 'MY') {
        // jurisdiction이 MY이면 entity_my로 리다이렉트
        // 경로 변환: /Entity -> /Entity_my, /entity -> /entity_my
        let redirectPath = to.path.replace(/^\/Entity(\/|$)/, '/Entity_my$1').replace(/^\/entity(\/|$)/, '/entity_my$1');
        
        // 쿼리 파라미터와 해시 유지
        const query = to.query;
        const hash = to.hash;
        
        next({
            path: redirectPath,
            query: query,
            hash: hash,
            replace: true // 히스토리에 남기지 않음
        });
    } else {
        // jurisdiction이 MY가 아니면 일반 Entity로 진행
        next();
    }
};

export const entityRoutes: RouteRecordRaw[] = [
    {
        path: '/Entity',
        name: 'EntityList',
        component: () => import('./views/EntityListPage.vue'),
        beforeEnter: checkJurisdictionNotMY,
        meta: {
            title: 'Entity Management',
            titleKey: 'entity.Entity Management',
            requiresAuth: true,
            layout: 'default',
        },
    },
    // 소문자 경로도 지원
    {
        path: '/entity',
        name: 'EntityListLower',
        component: () => import('./views/EntityListPage.vue'),
        beforeEnter: checkJurisdictionNotMY,
        meta: {
            title: 'Entity Management',
            titleKey: 'entity.Entity Management',
            requiresAuth: true,
            layout: 'default',
        },
    },
    // create 경로는 :id 파라미터 라우트보다 먼저 정의되어야 함
    {
        path: '/Entity/create',
        name: 'EntityCreate',
        component: () => import('./views/EntityCreatePage.vue'),
        beforeEnter: checkJurisdictionNotMY,
        meta: {
            title: 'Entity Create',
            titleKey: 'entity.Entity Create',
            requiresAuth: true,
            layout: 'default',
        },
    },
    {
        path: '/entity/create',
        name: 'EntityCreateLower',
        component: () => import('./views/EntityCreatePage.vue'),
        beforeEnter: checkJurisdictionNotMY,
        meta: {
            title: 'Entity Create',
            titleKey: 'entity.Entity Create',
            requiresAuth: true,
            layout: 'default',
        },
    },
    // edit 경로도 :id보다 먼저 정의
    {
        path: '/Entity/:id/edit',
        name: 'EntityEdit',
        component: () => import('./views/EntityEditPage.vue'),
        beforeEnter: checkJurisdictionNotMY,
        meta: {
            title: 'Entity Edit',
            titleKey: 'entity.Entity Edit',
            requiresAuth: true,
            layout: 'default',
        },
    },
    {
        path: '/entity/:id/edit',
        name: 'EntityEditLower',
        component: () => import('./views/EntityEditPage.vue'),
        beforeEnter: checkJurisdictionNotMY,
        meta: {
            title: 'Entity Edit',
            titleKey: 'entity.Entity Edit',
            requiresAuth: true,
            layout: 'default',
        },
    },
    // 마지막에 :id 파라미터 라우트 정의
    {
        path: '/Entity/:id',
        name: 'EntityDetail',
        component: () => import('./views/EntityDetailPage.vue'),
        beforeEnter: checkJurisdictionNotMY,
        meta: {
            title: 'Entity Detail',
            titleKey: 'entity.Entity Detail',
            requiresAuth: true,
            layout: 'default',
        },
    },
    {
        path: '/entity/:id',
        name: 'EntityDetailLower',
        component: () => import('./views/EntityDetailPage.vue'),
        beforeEnter: checkJurisdictionNotMY,
        meta: {
            title: 'Entity Detail',
            titleKey: 'entity.Entity Detail',
            requiresAuth: true,
            layout: 'default',
        },
    },
];

export default entityRoutes;

